import React, { useContext, useEffect, useState } from 'react';
import AppContext from '../Context/AppContext';
import axios from 'axios';
import moment from 'moment';

const VideoLocationLoad = () => {
    const { mapUrl } = useContext(AppContext)
    const [items, setItems] = useState(null)
    const [serverInfo, setServerInfo] = useState(null)
    const [openVideo, setOpenVideo] = useState(null)
    const initListServer = async () => {
        const response = await axios.get(mapUrl.stat_server_stream);
        setServerInfo(response.data)
    }
    const init = async () => {
        const url = mapUrl.cdn_video_location;
        const getItems = await axios.get(url);
        setItems(getItems.data)

    }
    useEffect(() => {
        init()
        initListServer()
    }, [])
    console.log(serverInfo);

    return (
        <div>
            {items?.length > 0 && serverInfo && items.map((item, i) => (
                <div className='px1 py1 fr'>
                    <div className='df fdc'>
                        <div className='mb1'>
                            <div className='df gap1'>
                                <p className='cw '>{moment(item.date).format('DD/MM HH:mm')}</p>
                                <p className='cw'>{item.server}</p>
                                <p className='cw '>{moment(item.last_watch).format('DD/MM HH:mm')}</p>
                            </div>
                            <p className='cw'>{item.video_name}</p>
                        </div>
                        {openVideo?.id == item.id && (
                            <video
                                controls
                                src={openVideo.video}
                                style={{ width: "100%", height: "500px" }}
                            />
                        )}
                        <button onClick={async () => {
                            const getToken = await axios.post(mapUrl.cdn_token_video, { nameVideo: item.video_name });
                            const token = getToken?.data;
                            const serverName = item.server;
                            const folder = item.video_name

                            const domaineServer = serverInfo?.statusServer[serverName].domain;
                            const urlVideo = domaineServer + "/hls/" + folder + "/master_free.m3u8?token=" + token;
                            setOpenVideo({ id: item.id, video: urlVideo })

                        }} className='card carder cw'>VIDEO</button>
                        <button onClick={async () => {
                            const id = item.id;
                            const response = await axios.post(mapUrl.cdn_finish_video, { id: id });
                            init()
                        }} className='px1 py1  cw bcs'>FINISH</button>
                        <button onClick={async () => {
                            const id = item.id;
                            const response = await axios.post(mapUrl.cdn_delete_video_location, { id: id });
                            init()

                        }} className='px1 py1  ce bcw'>SUPPRIMER</button>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default VideoLocationLoad;